'use strict';

var ChartSponsorForecastFlightDirective = function ChartSponsorForecastFlightDirective($timeout, Chart, Viewport, angularHelper) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-sponsor-forecast-flight.html'),
    controller: 'ChartSponsorForecastFlightController',
    scope: {
      leg: '=',
      flight: '=?',
      isVisible: '=?',
      selectedFlightSummary: '=',
      selectedBusinessId: '=?'
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement);
      scope.renderChartDataPresent = function (data, selectionSize) {
        if (element.is(':visible')) {
          chart.withYRange([scope.time.from, scope.time.to]).render(data);
          viewport.render(data, selectionSize);
        }
      };
      scope.timeRangeChangeHandler = function () {
        if (scope.time.from && scope.time.to) {
          chart.withYRange([scope.time.from, scope.time.to]).render();
        }
      };
      chart.on('flightclick', angularHelper.applyWrapper(scope, scope.flightSelectionHandler));
      viewport.on('rangechange', function (range) {
        chart.domainChange(range);
      });
      element.closest('.collapse').on('hidden.bs.collapse', scope.hidePanels).on('shown.bs.collapse', function () {
        scope.hidePanels();
        scope.initChart();
      });
      function refreshChart() {
        $timeout(function () {
          if (element.is(':visible') && scope.leg) {
            scope.initChart();
          }
        }, 0);
      }
      scope.$watch('leg', function () {
        if (scope.leg) {
          refreshChart();
        }
      });
      scope.$watch('isVisible', function () {
        if (scope.isVisible) {
          refreshChart();
        }
      });
    }
  };
};
ChartSponsorForecastFlightDirective.$inject = ['$timeout', 'ChartSponsorForecastFlight', 'ChartSponsorForecastFlightViewport', 'AngularHelper'];
module.exports = ChartSponsorForecastFlightDirective;